import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  CommonErrorMsg,
  confirmDelete,
  ErrorMsg,
  InfoIcon,
  sessionUser,
  ValidateForm,
} from "../../../Util/common";
import { corefetch, corepost, ImageURL } from "../../../Util/axios_core_helper";

import { toast } from "react-toastify";
import { KendoLoader } from "../../../Kendo/kendo_loader";
import { KendoGrid } from "../../../Kendo/kendo_grid";

const CalendlyLinks = () => {
  const modalRef = useRef(null);
  const [CalendlyLink, setcalendlyLinks] = useState({
    ID: 0,
    MeridianCalendlyLink: "",
    NON_MeridianCalendlyLink: "",
    Description: "",
  });
  const [MyBallroomList, setMyBallroomList] = useState({
    ID: 0,
    Title: "",
    Description: "",
    Image: "",
    PlayStoreURL: "",
    AppStoreURL: "",
    oldImagePath: "",
    ThumbImagePath: "",
  });
  const [editVisible, setEditVisible] = useState(false);
  const [error, setError] = useState({});
  const [HideAdd, setHideAdd] = useState(false);
  const [refreshGrid, setrefreshGrid] = useState(0);
  const [MyBallroomData, setMyBallroomData] = useState([]);
  const [Loading, setLoading] = useState(false);

  const clearForm = () => {
    $("#hide").click();
    setLoading(false);
    let temp = CalendlyLink;

    CalendlyLink.ID = 0;
    CalendlyLink.MeridianCalendlyLink = "";
    CalendlyLink.NON_MeridianCalendlyLink = "";
    CalendlyLink.Description = "";
    setcalendlyLinks(temp);
    const fileInput = document.querySelector('input[type="file"]');
    if (fileInput) {
      fileInput.value = null;
    }
    setError({});
    setEditVisible(false);
  };
  const onSubmit = async (e) => {
    e.preventDefault();

    const calendlyPattern = /^https:\/\/.*calendly.*$/;
    let hasError = false;

    // Validate MeridianCalendlyLink
    if (!CalendlyLink.MeridianCalendlyLink) {
      setError((prevError) => ({
        ...prevError,
        MeridianCalendlyLink: "Calendly Link is required.",
      }));
      hasError = true;
    } else if (!calendlyPattern.test(CalendlyLink.MeridianCalendlyLink)) {
      setError((prevError) => ({
        ...prevError,
        MeridianCalendlyLinkValid: "Please enter a valid Calendly URL.",
      }));
      hasError = true;
    }

    // Validate NON_MeridianCalendlyLink
    if (!CalendlyLink.NON_MeridianCalendlyLink) {
      setError((prevError) => ({
        ...prevError,
        NON_MeridianCalendlyLink: "Calendly Link is required.",
      }));
      hasError = true;
    } else if (!calendlyPattern.test(CalendlyLink.NON_MeridianCalendlyLink)) {
      setError((prevError) => ({
        ...prevError,
        NON_MeridianCalendlyLinkValid: "Please enter a valid Calendly URL.",
      }));
      hasError = true;
    }

    // **Validate Description**
    if (!CalendlyLink.Description || CalendlyLink.Description.trim() === "") {
      setError((prevError) => ({
        ...prevError,
        Description: "Note is required.",
      }));
      hasError = true;
    }

    if (hasError) return; // Prevent form submission if there are errors

    setLoading(true);

    const formData = new FormData();
    formData.append("ID", CalendlyLink.ID);
    formData.append("MeridianCalendlyLink", CalendlyLink.MeridianCalendlyLink);
    formData.append("Description", CalendlyLink.Description);
    formData.append(
      "NON_MeridianCalendlyLink",
      CalendlyLink.NON_MeridianCalendlyLink
    );
    formData.append("SavedBy", sessionUser());

    try {
      await corepost("Decoration/InsertUpdateCalendlyLink", formData);
      clearForm();
      setrefreshGrid(refreshGrid + 1);
      document.getElementById("MyBallroom-cancel").click();
    } catch (error) {
      console.error("Error submitting form:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleEditClick = async (e) => {
    let temp = CalendlyLink;

    CalendlyLink.ID = e.id;
    CalendlyLink.MeridianCalendlyLink = e.meridianCalendlyLink;
    CalendlyLink.NON_MeridianCalendlyLink = e.noN_MeridianCalendlyLink;
    CalendlyLink.Description = e.description;
    setcalendlyLinks(temp);

    setEditVisible(true);
    const modal = new bootstrap.Modal(
      document.getElementById("Add_MyBallroom")
    );
    modal.show();
  };

  const onValidation = (name, val) => {
    setError((prvErr) => {
      return {
        ...prvErr,
        [name]:
          !val || (val && val.trim() == "") || (val && val.trim().length == 0),
      };
    });
  };

  function validateStoreUrl(name, url) {
    const appStoreUrlPattern = /^https:\/\/.*apple.*$/;
    const playStoreUrlPattern = /^https:\/\/.*play\.google.*$/;

    if (name === "PlayStoreURL") {
      if (playStoreUrlPattern.test(url)) {
        setError((prevError) => ({ ...prevError, PlayStoreURLValid: false }));
        return false;
      } else {
        setError((prevError) => ({ ...prevError, PlayStoreURLValid: true }));
        return true;
      }
    } else if (name === "AppStoreURL") {
      if (appStoreUrlPattern.test(url)) {
        setError((prevError) => ({ ...prevError, AppStoreURLValid: false }));
        return false;
      } else {
        setError((prevError) => ({ ...prevError, AppStoreURLValid: true }));
        return true;
      }
    }

    return false;
  }

  const handleDeleteClick = async (e) => {
    const onDelete = () => {
      corefetch(
        `Decoration/DeleteCalendlyLinks?id=${e.id}&DeletedBy=${sessionUser()}`,
        true,
        false,
        true
      ).then(() => {
        setrefreshGrid(refreshGrid + 1);
      });
    };
    confirmDelete(onDelete);
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const list = await corefetch("Decoration/GetCalendlyLinks");
        setMyBallroomData(list);
        if (list && list.length > 0) {
          setHideAdd(true);
        } else {
          setHideAdd(false);
        }
      } catch (error) {
        console.error("Error fetching list:", error);
        setHideAdd(false);
      }
    };

    fetchData();
  }, [refreshGrid]);
  return (
    <>
      {" "}
      <div className="card bg-white">
        <div className="card-body">
          <div className="col-auto ms-auto">
            <div className="row">
              <div className="col-sm-6"></div>
              <div className="col-auto float-end ms-auto">
                <div className="d-flex justify-content-end mb-2">
                  {!HideAdd && (
                    <Button
                      name={"Add"}
                      dataBsToggle={"modal"}
                      dataBsTarget={"#Add_MyBallroom"}
                      dataBsDismiss={"modal"}
                    />
                  )}
                </div>
              </div>
            </div>

            <div>
              <KendoGrid
                name={"MyBallroom"}
                data={MyBallroomData}
                schema={{}}
                columns={[
                  {
                    field: "id",
                    filterable: false,
                    hidden: true,
                  },

                  {
                    field: "meridianCalendlyLink",
                    title: "Meridian Calendly Link",
                    width: 200,
                  },
                  {
                    field: "noN_MeridianCalendlyLink",
                    title: "NON_Meridian Calendly Link",

                    width: 200,
                  },
                  {
                    field: "description",
                    hidden: true,
                  },
                ]}
                showOptions={true}
                showEdit={true}
                showDelete={true}
                onEditClick={(e) => handleEditClick(e)}
                onDeleteClick={(e) => {
                  handleDeleteClick(e);
                }}
                disableExportExcel={true}
                width={"auto"}
                height={"60vh"}
                refreshWhen={refreshGrid}
                paggable={false}
                showSearch={false}
              />
            </div>
          </div>
        </div>
      </div>
      {/* <!-- Add MyBallroom Modal --> */}
      <div
        className="modal custom-modal fade"
        id="Add_MyBallroom"
        role="dialog"
        ref={modalRef}
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{editVisible ? "Edit" : "Add"}</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  clearForm();
                }}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form id="MyBallroomForm" onSubmit={onSubmit}>
                <input type="hidden" name="ID" value={CalendlyLink.ID || 0} />
                <div className="row">
                  <div className="col-md-12">
                    <label className="form-label">
                      Meridian Client Calendly Link{" "}
                      <span className="text-danger">*</span>
                    </label>
                    <textarea
                      className="form-control field"
                      name="MeridianCalendlyLink"
                      value={CalendlyLink.MeridianCalendlyLink || ""}
                      placeholder="Enter Calendly Link"
                      data-required="true"
                      onChange={(e) => {
                        const value = e.target.value.trim();
                        const calendlyPattern = /^https:\/\/.*calendly.*$/;

                        setcalendlyLinks((prev) => ({
                          ...prev,
                          MeridianCalendlyLink: value,
                        }));

                        setError((prevError) => {
                          const newError = { ...prevError };

                          if (!value) {
                            newError.MeridianCalendlyLink =
                              "Calendly Link is required.";
                            newError.MeridianCalendlyLinkValid = ""; // Clear invalid error
                          } else if (!calendlyPattern.test(value)) {
                            newError.MeridianCalendlyLink = ""; // Clear required error
                            newError.MeridianCalendlyLinkValid =
                              "Please enter a valid Calendly URL.";
                          } else {
                            newError.MeridianCalendlyLink = "";
                            newError.MeridianCalendlyLinkValid = "";
                          }

                          return newError;
                        });

                        //onValidationURL("MeridianCalendlyLinkValid", value);
                      }}
                    />
                    <CommonErrorMsg
                      text={
                        error.MeridianCalendlyLink
                          ? "Calendly Link is required"
                          : error.MeridianCalendlyLinkValid
                          ? "Please enter a valid Calendly URL"
                          : ""
                      }
                      IsError={
                        error.MeridianCalendlyLink ||
                        error.MeridianCalendlyLinkValid
                      }
                    />
                  </div>
                  <br></br>
                  <div className="col-md-12">
                    <label className="form-label">
                      NON-Meridian Client Calendly Link{" "}
                      <span className="text-danger">*</span>
                    </label>
                    <textarea
                      className="form-control field"
                      name="NON_MeridianCalendlyLink"
                      value={CalendlyLink.NON_MeridianCalendlyLink || ""}
                      placeholder="Enter Calendly Link"
                      data-required="true"
                      onChange={(e) => {
                        const value = e.target.value.trim();
                        const calendlyPattern = /^https:\/\/.*calendly.*$/;

                        setcalendlyLinks((prev) => ({
                          ...prev,
                          NON_MeridianCalendlyLink: value,
                        }));

                        setError((prevError) => {
                          const newError = { ...prevError };

                          if (!value) {
                            newError.NON_MeridianCalendlyLink =
                              "Calendly Link is required.";
                            newError.NON_MeridianCalendlyLinkValid = ""; // Clear invalid error
                          } else if (!calendlyPattern.test(value)) {
                            newError.NON_MeridianCalendlyLink = ""; // Clear required error
                            newError.NON_MeridianCalendlyLinkValid =
                              "Please enter a valid Calendly URL.";
                          } else {
                            newError.NON_MeridianCalendlyLink = "";
                            newError.NON_MeridianCalendlyLinkValid = "";
                          }

                          return newError;
                        });
                      }}
                    />
                    <CommonErrorMsg
                      text={
                        error.NON_MeridianCalendlyLink
                          ? "Calendly Link is required"
                          : error.NON_MeridianCalendlyLinkValid
                          ? "Please enter a valid Calendly URL"
                          : ""
                      }
                      IsError={
                        error.NON_MeridianCalendlyLink ||
                        error.NON_MeridianCalendlyLinkValid
                      }
                    />
                  </div>
                  <div className="col-md-12">
                    <label className="form-label">
                      Note<span className="text-danger">*</span>
                      <InfoIcon content="Please provide a Note with a maximum length of 200 characters." />
                    </label>
                    <textarea
                      type="text"
                      maxLength={200}
                      className="form-control field"
                      name="Description"
                      id="Description"
                      value={CalendlyLink.Description || ""}
                      placeholder="Description"
                      data-required="true"
                      onChange={(e) => {
                        setcalendlyLinks((prev) => ({
                          ...prev,
                          Description: e.target.value,
                        }));
                        onValidation("Description", e.target.value);
                      }}
                    />

                    <CommonErrorMsg
                      text="Note is required"
                      IsError={error.Description}
                    />
                  </div>
                </div>
                {Loading ? (
                  <KendoLoader className="d-flex justify-content-end align-items-center" />
                ) : (
                  <div className="text-end">
                    <Button
                      name={"Cancel"}
                      isCancelButton={true}
                      id="MyBallroom-cancel"
                      dataBsDismiss={"modal"}
                      onClick={() => {
                        clearForm();
                      }}
                    />

                    <Button name={editVisible ? "Update" : "Save"} />
                  </div>
                )}
                <button
                  type="button"
                  id="hide"
                  style={{ display: "none" }}
                  data-bs-dismiss={"modal"}
                  onClick={() => {
                    clearForm();
                  }}
                ></button>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- Add MyBallroom Modal --> */}
    </>
  );
};

export default CalendlyLinks;
